/**
 * Whether a sign-in must ask for credentials again, after one the site refused: B2C would
 * otherwise sign the same account in silently. Local storage, as MSAL's sign-in is, so it holds in
 * every tab and survives a reload and a redirect that never started; it is cleared once the site's
 * session starts. Storage that cannot be used only loses the prompt.
 */

/** Namespaced: the origin is shared with MSAL's own storage. */
const storageKey = 'tms.auth.freshSignIn'

/** Makes every sign-in ask for credentials until the site's session starts. */
export function requireFreshSignIn(): void {
  try {
    localStorage.setItem(storageKey, '1')
  } catch {
    // Storage blocked: B2C may sign the same account in again, and the site refuses it again.
  }
}

/** Whether a sign-in must ask for credentials. */
export function isFreshSignInRequired(): boolean {
  try {
    return localStorage.getItem(storageKey) !== null
  } catch {
    return false
  }
}

/** Lets sign-ins use B2C's own session again, once the site's session has started. */
export function clearFreshSignIn(): void {
  try {
    localStorage.removeItem(storageKey)
  } catch {
    // Nothing to clear.
  }
}
